import Quill from 'quill';
const Inline = Quill.import('blots/inline');

class ErrorLine extends Inline {
  static blotName = 'error';
  static tagName = 'span';
  static create(value) {
    const node = super.create();
    // 使用 SVG 背景生成红色波浪线
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><path d="M0 3 Q 1 4 2 3 T 4 3" stroke="#ff0000" fill="none" stroke-width="0.8"/></svg>`;
    node.style.backgroundImage = `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
    node.style.backgroundRepeat = 'repeat-x';
    node.style.backgroundPosition = '0 calc(100% - 1px)';
    node.style.backgroundSize = 'auto 6px';
    node.style.paddingBottom = '4px';
    node.setAttribute('data-type', 'error');
    node.setAttribute('data-error_id', value.id);
    return node;
  }
  static formats(node) {
    if (node.getAttribute('data-type') == 'error') {
      return {
        type: node.getAttribute('data-type'),
        id: node.getAttribute('data-error_id'),
      };
    }
  }
  static value(node) {
    // 反向解析：从 DOM 节点还原格式值（用于复制/粘贴保留样式）
    return this.formats(node);
  }
}
class AILine extends Inline {
  static blotName = 'ai';
  static tagName = 'span';
  static create(value) {
    const node = super.create();
    // 使用 SVG 背景生成红色波浪线
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="4" height="4"><path d="M0 3 Q 1 4 2 3 T 4 3" stroke="#0000ff" fill="none" stroke-width="0.8"/></svg>`;
    node.style.backgroundImage = `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
    node.style.backgroundRepeat = 'repeat-x';
    node.style.backgroundPosition = '0 calc(100% - 1px)';
    node.style.backgroundSize = 'auto 6px';
    node.style.paddingBottom = '4px';
    node.setAttribute('data-type', 'ai');
    node.setAttribute('data-ai_id', value.id);
    return node;
  }
  static formats(node) {
    if (node.getAttribute('data-type') == 'ai') {
      return {
        type: node.getAttribute('data-type'),
        id: node.getAttribute('data-ai_id'),
      };
    }
  }
  static value(node) {
    // 反向解析：从 DOM 节点还原格式值（用于复制/粘贴保留样式）
    return this.formats(node);
  }
}
// 注册自定义 Blot
Quill.register(ErrorLine);
Quill.register(AILine);
